module.exports = __webpack_public_path__ + "static/img/1.001a9a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/1.png
// module id = DP4o
// module chunks = 4